<ng-template #confirmationModal let-c="close">
  <div *ngIf="headerText" class="modal-header">
    <div class="modal-title">{{ headerText | translate }}</div>
  </div>
  <div class="modal-body">
    <div class="modal-body-content mb-4">{{ body | translate }}</div>
    <div class="d-flex w-100" [ngClass]="cancelText ? 'justify-content-between' : 'justify-content-around'">
      <button *ngIf="cancelText" type="button" class="btn btn-default" (click)="c()">{{ cancelText | translate }}</button>
      <button type="button" [ngClass]="'btn ' + confirmButtonClass" (click)="c(true)">{{ confirmText }}</button>
    </div>
  </div>
</ng-template>
